import { ZodSchema } from 'zod';
import { ZodError } from 'zod/lib/ZodError';

type ErrorType = ZodError;

export interface ValidationResult {
  readonly isValid: boolean;
  readonly error?: ErrorType;
}

export const zodNativeValidatorResolver = (schema: ZodSchema) => (formValues: {}): ValidationResult => {
  const result = schema.safeParse(formValues);
  if (result.success) {
    return { isValid: true };
  }

  return {
    isValid: false,
    error: result.error,
  };
};
